import { Host, h } from '@stencil/core';
export class AibaCloseButton {
  constructor() {
    this.icon = undefined;
    this.text = undefined;
    this.textOnly = true;
    this.iconOnly = false;
    this.altText = undefined;
    this.classes = undefined;
    this.styles = undefined;
    this.handleClick = undefined;
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), this.iconOnly === true && this.icon && (h("button", { class: this.classes ? this.classes : '', onClick: event => this.handleClick(event) }, h("img", { src: this.icon, alt: this.altText }))), this.textOnly === true && this.text && (h("button", { class: this.classes ? this.classes : '', "aria-label": this.text, onClick: event => this.handleClick(event) }, this.text))));
  }
  static get is() { return "aiba-close-button"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-close-button.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-close-button.css"]
    };
  }
  static get properties() {
    return {
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon",
        "reflect": false
      },
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "text",
        "reflect": false
      },
      "textOnly": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "text-only",
        "reflect": false,
        "defaultValue": "true"
      },
      "iconOnly": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-only",
        "reflect": false,
        "defaultValue": "false"
      },
      "altText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "alt-text",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-close-button.js.map
